/* eslint-disable no-underscore-dangle */
// modules
import { createSelector } from 'reselect'
import * as R from 'ramda'
// views
import { sendFieldHeightView, windowView } from '$comp/main/root.reducer'

// TODO: Refactor
const getDimSelector = createSelector(
  [windowView, sendFieldHeightView],
  (windowObj, sendFieldHeight) => {
    const leftDrawerOpen = false
    const rightDrawerOpen = false

    const chatBody = R.compose(
      R.unless(() => windowObj.width > 640, R.always(windowObj.width)),
      R.when(R.always(leftDrawerOpen), R.subtract(R.__, 351)),
      R.when(R.always(rightDrawerOpen), R.subtract(R.__, 351)),
    )(windowObj.width)

    return {
      dim: {
        browser: { width: windowObj.width, height: windowObj.height },
        chat: { sendFieldHeight, chatBody },
      },
      size: {
        mobile: windowObj.width < 640,
      },
    }
  },
)

export default getDimSelector
